<template>
  <div class="done-invoice-info">
    <main>
      <ModuleHeadText :title="`基本信息 （${getInvoiceImgOrName('abbr')}）`" />
      <div class="card negative-invoice">
        <van-field v-model="invoiceInfo.drewDate" label="开票日期" placeholder="自动填入" readonly />
        <van-field v-if="!isAllElectricType" v-model="invoiceInfo.invoiceCode" label="发票代码" placeholder="自动填入" readonly />
        <van-field v-model="invoiceInfo.invoiceNo" label="发票号码" placeholder="自动填入" readonly />
        <van-field v-if="!isAllElectricType" v-model="invoiceInfo.checkCode" label="校验码" placeholder="自动填入" readonly />
        <EllipticMark v-if="invoiceInfo.billingType === 1" :style="{ top: '0px', transform: 'translateY(0)',  width: '80px', height: '35px'  }" type="error" text="负数发票" />
        <EllipticMark v-else :style="{ top: '0px', transform: 'translateY(0)', width: '80px', height: '35px'  }" type="success" text="正数发票" />
        <EllipticMark v-if="invoiceInfo.invoiceStatus === 20 || invoiceInfo.invoiceStatus === 21" :style="{ top: '40px', transform: 'translateY(0)', width: '80px', height: '35px'  }" type="error" text="已红冲" />
      </div>
      <ModuleHeadText title="订单和金额" />
      <div class="card">
        <Table
          :tableData="invoiceInfo.details"
          :columns="columns"
        >
        </Table>
      </div>
      <div class="card margin-top-16">
        <van-field v-model="invoiceInfo.amountWithTax" label="金额(含税)" placeholder="自动填入" readonly />
        <van-field v-model="invoiceInfo.amount" label="金额(不含税)" placeholder="自动填入" readonly />
        <van-field v-model="invoiceInfo.taxAmount" label="税额" placeholder="自动填入" readonly />
      </div>
      <ModuleHeadText title="抬头信息" />
      <div class="card">
        <div class="buyer-and-seller">
          <span @click="() => handleChangeSelect(0)" :class="flag === 0 ? 'select' : ''">购方</span>
          <span @click="() => handleChangeSelect(1)" :class="flag === 1 ? 'select' : ''">销方</span>
        </div>
        <template v-if="flag === 1">
          <van-field v-model="invoiceInfo.sellerName" label="销方名称" placeholder="自动填入" readonly />
          <van-field v-model="invoiceInfo.sellerTaxNo" label="纳税人识别号" placeholder="自动填入" readonly />
          <template v-if="!isAllElectricType">
            <van-field v-model="invoiceInfo.sellerAddress" label="地址、电话" placeholder="自动填入" readonly />
            <van-field v-model="invoiceInfo.sellerBankName" label="开户行、账号" placeholder="自动填入" readonly />
          </template>
        </template>
        <template v-else>
          <van-field v-model="invoiceInfo.purchaserName" label="购方名称" placeholder="" readonly />
          <van-field v-model="invoiceInfo.purchaserTaxNo" label="纳税人识别号" placeholder="" readonly />
          <template v-if="!isAllElectricType">
            <van-field v-model="invoiceInfo.purchaserAddress" label="地址、电话" placeholder="" readonly />
            <van-field v-model="invoiceInfo.purchaserBankName" label="开户行、账号" placeholder="" readonly />
          </template>
        </template>
      </div>
      <ModuleHeadText title="其他信息" />
      <div class="card">
        <van-field v-model="invoiceInfo.remark" label="备注" placeholder="" readonly />
        <template v-if="!isAllElectricType">
          <van-field v-model="invoiceInfo.payee" label="收款人" placeholder="" readonly />
          <van-field v-model="invoiceInfo.reviewer" label="复核人" placeholder="" readonly />
        </template>
        <van-field v-model="invoiceInfo.drawer" label="开票人" placeholder="" readonly />
      </div>
    </main>
    <footer>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('redInvoice')"
        >
          <span>负数发票开具</span>
        </MainButton>
      </div>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('copyInvoicing')"
        >
          <span>复制开票</span>
        </MainButton>
      </div>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('sendMail')"
        >
          <span>发送邮箱/短信</span>
        </MainButton>
      </div>
    </footer>
    <van-overlay class-name="download-pop" z-index="999" :show="showDownload" @click="showDownload = false">
      <div class="wrapper" @click.stop>
        <van-field v-model="sendInfo.mailAddress" label="邮箱地址" placeholder="请输入" />
        <van-field v-model="sendInfo.purchaserPhone" label="手机号码" placeholder="请输入" />
        <div>
          <MainButton
            :handleClick="() => handleBtnClick('sendEmail')"
          >
            <span>确认发送</span>
          </MainButton>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Field, Toast, Overlay, Notify } from 'vant'
import { INVOICE_TYPE_IMG_AND_NAME_MAP } from '@/assets/config.js'
import ModuleHeadText from '@/components/ModuleHeadText/index.vue'
import EllipticMark from '@/components/EllipticMark/index.vue'
import MainButton from '@/components/MainButton/index.vue'
import { isAllElectric, uuid, onCount, isSpecialTicket, aesDoEncrypt } from '@/utils/basicUtil'
import Table from '@/components/Table/index.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  components: {
    Table,
    MainButton,
    EllipticMark,
    ModuleHeadText,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Overlay.name]: Overlay
  },
  computed: {
    ...mapState('doneInvoiceListModel', ['invoiceInfo']),
    getInvoiceImgOrName () {
      return (type) => {
        let data = ''
        if (INVOICE_TYPE_IMG_AND_NAME_MAP.find(i => i.value === this.invoiceInfo.invoiceType)) {
          data = INVOICE_TYPE_IMG_AND_NAME_MAP.find(i => i.value === this.invoiceInfo.invoiceType)[type]
        }
        return data
      }
    },
    isAllElectricType () {
      return isAllElectric(this.invoiceInfo.invoiceType)
    }
  },
  data () {
    return {
      id: '',
      flag: 0,
      showDownload: false,
      sendInfo: {
        mailAddress: '',
        purchaserPhone: '',
        invoiceIds: [],
        defaultSend: 0,
        source: 2
      },
      columns: [
        { title: '货物或应税劳务', dataIndex: 'goodsName', width: '107px', type: 'goodName' },
        { title: '含税单价', dataIndex: 'price', width: '69px', align: 'right', type: 'money' },
        { title: '数量', dataIndex: 'quantity', type: 'money' },
        { title: '含税金额', dataIndex: 'amountWithTax', width: '69px', align: 'right', type: 'money' },
        { title: '税率', dataIndex: 'taxRate', type: 'percentage' }
      ]
    }
  },
  mounted () {

  },
  activated () {
    const { id } = this.$route.query
    this.id = id
    this.getInvoiceInfo()
  },
  methods: {
    ...mapActions('doneInvoiceListModel', ['getInvoiceInfoById', 'sendEmailAndPhone']),
    ...mapMutations('doneInvoiceListModel', ['setInvoiceInfo']),
    async getInvoiceInfo () {
      Toast.loading({
        message: '查询中...',
        duration: 0
      })
      await this.getInvoiceInfoById(this.id)
      Toast.clear({
        clearAll: true
      })
    },
    handleChangeSelect (flag) {
      this.flag = flag
    },
    async handleBtnClick (type) {
      if (type === 'sendMail') {
        this.sendInfo.invoiceIds = [this.invoiceInfo.id]
        this.sendInfo.mailAddress = this.invoiceInfo.purchaserEmail
        this.sendInfo.purchaserPhone = this.invoiceInfo.purchaserPhone
        this.showDownload = true
      }
      if (type === 'sendEmail') {
        const flag = await this.sendEmailAndPhone(this.sendInfo)
        if (flag) return
        this.getInvoiceInfo()
        this.showDownload = false
      }
      if (type === 'copyInvoicing') {
        this.$store.commit('invoice/replaceInvoiceOpeningInfo', {
          purchaserBankAccount: this.invoiceInfo.purchaserBankAccount,
          purchaserBankName: this.invoiceInfo.purchaserBankName,
          purchaserAddress: this.invoiceInfo.purchaserAddress,
          purchaserPhone: this.invoiceInfo.purchaserPhone,
          purchaserName: this.invoiceInfo.purchaserName,
          purchaserEmail: this.invoiceInfo.purchaserEmail,
          purchaserTel: this.invoiceInfo.purchaserTel,
          purchaserTaxNo: this.invoiceInfo.purchaserTaxNo,
          purchaserCode: this.invoiceInfo.purchaserCode,
          remark: this.invoiceInfo.remark,
          payee: this.invoiceInfo.payee,
          reviewer: this.invoiceInfo.reviewer,
          listFlag: this.invoiceInfo.listFlag,
          invoiceType: this.invoiceInfo.invoiceType
        })
        const details = []
        this.invoiceInfo.details.forEach((v, i) => {
          v.key = uuid() + i
          v.order = i + 1
          v.count = v.quantity
          v.money = v.amount
          v.moneyTax = v.amountWithTax
          v.tax = v.taxAmount
          if (v.quantity) {
            v.unitPriceWithTax = Number(onCount.div(v.amountWithTax || 0, v.quantity)).toFixed(8) // 含税
            v.price = Number(onCount.div(v.amountWithTax || 0, v.quantity)).toFixed(8) // 含税
          }
          v.priceTax = v.unitPriceWithTax
          v.moneyTax = onCount.add(v.money, v.tax).toFixed(2)
          v.sortName = v.shortName = v.shortName.split('*').join('')
          v.taxSign = 0
          v.xsyhzc = v.taxPre
          v.yhzclx = v.taxPreType
          v.fphxz = v.invoiceLineType
          if (v.price === 0 || v.count === 0) {
            v.price = ''
            v.priceTax = ''
            v.count = ''
          }
          if (v.invoiceLineType === 1) {
            v.count = ''
            v.price = ''
            v.priceTax = ''
          }
          v.measurementUnit = v.unit
          v.specificationType = v.specification
          if (v.money < 0) {
            if (details[details.length - 1]) {
              details[details.length - 1].fphxz = 2
              details[details.length - 1].discountFlag = 2
              details[details.length - 1].discountRate = Number(Number((onCount.div(-v.amountWithTax || 0, details[details.length - 1].amountWithTax || 0) * 100) || 0).toFixed(2))
              details[details.length - 1].index = i - 1
              v.index = i - 1
              v.discountFlag = 1
              v.fphxz = 1
            }
          }
          details.push(v)
        })
        sessionStorage.nowGoodsMessage = JSON.stringify(details)
        sessionStorage.goods = JSON.stringify(details)
        this.$router.push('/invoice-opening/index')
      }
      if (type === 'redInvoice') {
        if (isSpecialTicket(this.invoiceInfo.invoiceType) || isAllElectric(this.invoiceInfo.invoiceType)) {
          Notify({ type: 'danger', message: '红冲暂不支持专票和数电票！' })
          return
        }
        if (this.invoiceInfo.billingType === 1 || this.invoiceInfo.invoiceStatus === 20 || this.invoiceInfo.invoiceStatus === 21) {
          Notify({ type: 'danger', message: '红冲发票无法红冲！' })
          return
        }
        this.$router.push(`/invoice-red/index?key=${aesDoEncrypt({
          invoiceNo: this.invoiceInfo.invoiceNo,
          invoiceCode: this.invoiceInfo.invoiceCode
        })}`)
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less" />
